module.exports = __webpack_public_path__ + "img/icon-male.1a66c828.png";